/**
 * Formats an ordinal number.
 *
 * __> Example:__
 * ```ts
 * formatOrdinalNumber(1);
 * // '1st'
 * formatOrdinalNumber(3);
 * // '3rd'
 * ```
 */

// logic shamelessly stolen from SO, i am not smrt
// https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number/13627586#13627586
export const formatOrdinalNumber: FormatOrdinalNumber = (value) => {
  const remainderOf10: any = value % 10;
  const remainderOf100: any = value % 100;

  if (remainderOf10 === 1 && remainderOf100 !== 11) {
    return `${value}st`;
  }
  if (remainderOf10 === 2 && remainderOf100 !== 12) {
    return `${value}nd`;
  }
  if (remainderOf10 === 3 && remainderOf100 !== 13) {
    return `${value}rd`;
  }
  return `${value}th`;
};

type FormatOrdinalNumber = (value: number) => string;
